(function () {
  function initVDOBLE(root) {
    if (!root || root.dataset.vdobleReady === 'true') return;
    root.dataset.vdobleReady = 'true';

    var filters = root.querySelectorAll('[data-vd-filter]');
    var cards = root.querySelectorAll('[data-vd-category]');

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        var selected = button.getAttribute('data-vd-filter');
        filters.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          card.classList.toggle('is-hidden', selected !== 'all' && card.getAttribute('data-vd-category') !== selected);
        });
      });
    });

    var dayButtons = root.querySelectorAll('[data-vd-day]');
    var panels = root.querySelectorAll('[data-vd-panel]');

    dayButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selected = button.getAttribute('data-vd-day');
        dayButtons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-vd-panel') === selected);
        });
      });
    });

    root.querySelectorAll('a[href^="#vd-"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var purchaseModal = root.querySelector('[data-vd-purchase-modal]');
    var purchaseForm = root.querySelector('[data-vd-purchase-form]');
    var purchaseButtons = root.querySelectorAll('[data-vd-purchase]');
    var lastPurchaseButton = null;

    function closePurchaseModal() {
      if (!purchaseModal) return;
      purchaseModal.classList.remove('is-open');
      purchaseModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vd-modal-open');
      if (lastPurchaseButton) lastPurchaseButton.focus();
    }

    function openPurchaseModal(button) {
      if (!purchaseModal || !purchaseForm) return;
      lastPurchaseButton = button;
      purchaseForm.reset();
      purchaseForm.querySelector('[data-vd-variant-id]').value = button.getAttribute('data-variant-id') || '';
      purchaseForm.querySelector('[data-vd-selling-plan-id]').value = button.getAttribute('data-selling-plan-id') || '';
      purchaseModal.querySelector('[data-vd-selected-plan]').textContent = button.getAttribute('data-plan-name') || 'Cuota';
      purchaseModal.querySelector('[data-vd-selected-price]').textContent = button.getAttribute('data-plan-price') || '';
      purchaseModal.querySelector('[data-vd-subscription-notice]').hidden = !button.getAttribute('data-selling-plan-id');
      purchaseModal.querySelector('[data-vd-purchase-error]').textContent = '';
      purchaseModal.classList.add('is-open');
      purchaseModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vd-modal-open');
      window.setTimeout(function () {
        var firstField = purchaseForm.querySelector('input:not([type="hidden"])');
        if (firstField) firstField.focus();
      }, 50);
    }

    purchaseButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        openPurchaseModal(button);
      });
    });

    root.querySelectorAll('[data-vd-purchase-close]').forEach(function (button) {
      button.addEventListener('click', closePurchaseModal);
    });

    if (purchaseModal) {
      purchaseModal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closePurchaseModal();
      });
    }

    if (purchaseForm) {
      purchaseForm.addEventListener('submit', function (event) {
        event.preventDefault();

        var error = purchaseForm.querySelector('[data-vd-purchase-error]');
        var submit = purchaseForm.querySelector('[type="submit"]');
        if (!purchaseForm.checkValidity()) {
          purchaseForm.reportValidity();
          error.textContent = 'Revisa los campos obligatorios antes de continuar.';
          return;
        }

        var variantId = purchaseForm.querySelector('[data-vd-variant-id]').value;
        var sellingPlanId = purchaseForm.querySelector('[data-vd-selling-plan-id]').value;
        var item = {
          id: Number(variantId),
          quantity: 1,
          properties: {
            'Nombre del alumno': purchaseForm.elements.student_name.value.trim(),
            'Teléfono del alumno o tutor': purchaseForm.elements.student_phone.value.trim(),
            'Email del alumno': purchaseForm.elements.student_email.value.trim(),
            'Clases y horarios elegidos': purchaseForm.elements.selected_classes.value.trim(),
            'Plaza sujeta a confirmación': 'Sí',
            'Acepta política de privacidad': 'Sí'
          }
        };

        if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

        var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

        error.textContent = '';
        submit.disabled = true;
        submit.textContent = 'Preparando el pago…';

        fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || data.message || 'No se ha podido preparar el pago.');
              });
            }
            return response.json();
          })
          .then(function () {
            window.location.href = shopRoot + 'checkout';
          })
          .catch(function (requestError) {
            error.textContent = requestError.message || 'No se ha podido preparar el pago. Inténtalo de nuevo.';
            submit.disabled = false;
            submit.textContent = 'Continuar al pago';
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-vdoble-home]').forEach(initVDOBLE);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
